import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkSession, clearCredentials } from '@/store/auth/authSlice';
import { selectToken } from '@/store/auth/authSelectors';

/**
 * Runs on app startup to restore the session from the persisted token.
 * If a token exists, validates it via GET /auth/me.
 * If no token, clears the initializing state immediately.
 * Returns null — purely side-effect component.
 */
const AppInitializer = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const sessionLoaded = useRef(false);

  useEffect(() => {
    if (token && !sessionLoaded.current) {
      dispatch(checkSession());
      sessionLoaded.current = true;
    } else if (!token) {
      dispatch(clearCredentials());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run once on mount only

  return null;
};

export default AppInitializer;
